// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__Ut9Sq","nav":"Menu_nav__x+YqG","logoLink":"Menu_logoLink__SFm1q"};